$(function() {

  $('.quantity-stepper').each(function(){
    var $this = $(this);
    var $input = $this.find('input');
    var $up = $this.find('.quantity-stepper__plus');
    var $down = $this.find('.quantity-stepper__minus');
    var config = {
      min: parseInt($input.attr('min')) || 1,
      max: parseInt($input.attr('max')) || 20,
      step: $input.data('step-value') || 1,
    };
    $input.val(stepperSetStartVal($input, config));
    $up.on('click', function(){
      console.log('up');
      $input.val(stepperUp($input, config));
    });
    $down.on('click', function(){
      $input.val(stepperDown($input, config));
    });
  });

});


function stepperSetStartVal($input, config){
  return ($input.val() > config.min && $input.val() < config.max) ? parseInt($input.val()) : config.min;
}

function stepperUp($input, config){
  var newVal = parseInt($input.val()) + config.step;
  if(newVal > config.max){
    newVal = config.max;
  }

  return newVal;
}

function stepperDown($input, config){
  var newVal = parseInt($input.val()) - config.step;
  if(newVal < config.min){
    newVal = config.min;
  }

  return newVal;
}
